export default "__VITE_ASSET__CuUbXfeB__"